import React from 'react';
import axios from 'axios';
import {BASE_URL_OSLOG} from "../../constants/ActionTypes";
import Error404 from 'components/Error404';

class EmbeddTrackingMonitoring extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            height: null,
            width: null
        }
    }

    signInToOslogJyoti = async(username, password) => {
        const URL = `${BASE_URL_OSLOG}/embedd/auth?username=${username}&password=${password}&embedd=true`;
        console.log(URL)
    
        return await axios({
            headers: {
                'Accept': 'application/json',
            },
            method: 'get',
            url: URL,
            withCredentials: true,
        }).then((response) => response).catch((error) => error.response);
    }

    async componentDidMount() {
        var body = document.body,
            html = document.documentElement;

        var height = Math.max( body.scrollHeight, body.offsetHeight, 
            html.clientHeight, html.scrollHeight, html.offsetHeight );
        var width = Math.max( body.scrollWidth, body.offsetWidth, 
            html.clientWidth, html.scrollWidth, html.offsetWidth );
        this.setState({height: height, width: width})

        const { search } = this.props.location
        const params = new URLSearchParams(search);
        const username = params.get('username');
        const password = params.get('password');
        await this.signInToOslogJyoti(username, password)
        // this.props.history.push(`/embedd/tracking-monitoring?password=${password}&username=${username}`)
    };

    render() {
        const url = `${BASE_URL_OSLOG}/embedd/tracking/mapMonitoring`;
        console.log("height: ", this.state.height);
        console.log("width: ", this.state.width);
        if (this.state.height !== null && this.state.width !== null) {
            return (
                <div>
                    <iframe id="frame-embedd" src={url}
                        style={{
                            width: `${this.state.width}px`,
                            height: `${this.state.height}px`,
                        }}
                        scrolling="no" 
                        frameBorder="0"
                    ></iframe>
                </div>
            );
        } else {
            return (
                <div>
                    <Error404/>
                </div>
            );
        }
    }
}

export default EmbeddTrackingMonitoring;


// WEBPACK FOOTER //
// ./containers/EmbeddTrackingMonitoring/index.js